export function constructSnippet(isToggled: boolean) {
  return `
<style>
  @keyframes fadeFromTransparent {
    from {
      opacity: 0;
    }
  }

  .icon-btn {
    opacity: 0.7;
    animation: fadeFromTransparent 1000ms;

    &:hover, &:active, &:focus-visible {
      opacity: 1;
    }
  }
</style>

${isToggled ? `<button class="icon-btn">...</button>` : ''}
`;
}
